import { useState, useEffect, useCallback } from "react";
import { getTags } from "../../../../screens/Tags/services/TagServices";

export const useEventTags = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Carregar tags na inicialização
  useEffect(() => {
    loadTags();
  }, []);

  const loadTags = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const allTags = await getTags();
      setTags(allTags.results || []);
    } catch (err) {
      setError(err.message || "Erro ao carregar tags");
      console.error("Erro ao carregar tags:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Converter string de tags para array de objetos para o react-select
  const parseTagsString = useCallback(
    (tagsString) => {
      if (!tagsString || typeof tagsString !== "string") return [];

      return tagsString
        .split(",")
        .map((tagName) => tagName.trim())
        .filter((tagName) => tagName.length > 0)
        .map((tagName) => {
          // Procurar tag existente (apenas tags existentes são permitidas)
          const existingTag = tags.find(
            (tag) => tag.key_name === tagName
          );

          if (existingTag) {
            return {
              value: existingTag.key_name,
              label: existingTag.key_name,
              color: existingTag.color,
              id: existingTag.id,
              isExisting: true,
              usage_count: existingTag.usage_count,
              category: existingTag.category,
            };
          }

          // Se a tag não existe, não retornamos nada (filtrado abaixo)
          return null;
        })
        .filter(Boolean); // Remove valores null/undefined
    },
    [tags]
  );

  // Converter array de objetos do react-select para string
  const formatTagsForSave = useCallback((selectedTags) => {
    if (!selectedTags || selectedTags.length === 0) return "";

    return selectedTags
      .filter((tag) => tag && tag.value) // Garante que só tags válidas sejam incluídas
      .map((tag) => tag.value)
      .join(", ");
  }, []);

  // Preparar opções para o react-select
  const getTagOptions = useCallback(() => {
    return tags.map((tag) => ({
      value: tag.key_name,
      label: tag.name,
      color: tag.color,
      id: tag.id,
      isExisting: true,
      usage_count: tag.usage_count || 0,
      category: tag.category,
    }));
  }, [tags]);

  return {
    tags,
    loading,
    error,
    loadTags,
    parseTagsString,
    formatTagsForSave,
    getTagOptions,
  };
};
